import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import * as Common from '_common';
import * as Components from '_components';
import React from 'react';
export function RenderDebugTextFrame(component, index) {
    return (_jsx(DebugTextFrame, { component: component, index: index }));
}
export function RenderDebugTextFrameToggle(component, index) {
    return (_jsx(DebugTextFrameToggle, { component: component, index: index }));
}
var DebugTextFrameContext = React.createContext(null);
export function DebugTextFrame(props) {
    var [codeVisible, setCodeVisible] = React.useState(false);
    var style = {
        border: props.component.properties.border ?? "1px dotted darkgray",
        width: props.component.properties.width ?? "calc(100% - 4em)",
        height: props.component.properties.height ?? "100%",
        margin: props.component.properties.margin ?? "1em",
        padding: props.component.properties.padding ?? "1em",
    };
    if (codeVisible) {
        style.overflow = "auto";
    }
    return (_jsx("div", { style: style, children: _jsx(DebugTextFrameContext.Provider, { value: props.component, children: _jsx(Components.SimpleComponentContent, { component: props.component }) }) }));
}
export function DebugTextFrameToggle(props) {
    var [codeVisible, setCodeVisible] = React.useState(false);
    var context = React.useContext(DebugTextFrameContext);
    return (_jsxs(_Fragment, { children: [_jsxs("div", { children: [codeVisible && _jsx(DebuxTextFrameCode, { component: context ?? props.component }), codeVisible || _jsx(Components.SimpleComponentContent, { component: props.component })] }), _jsx("div", { style: { textAlign: 'right' }, children: _jsx(Components.Button, { onClick: () => setCodeVisible(!codeVisible), children: "<>" }) })] }));
}
export function DebuxTextFrameCode(props) {
    var [source, setSource] = React.useState("");
    React.useEffect(() => {
        try {
            var componentsTonder = filterDebugComponents([props.component]);
            setSource(() => buildTsxForChildren(componentsTonder, ""));
        }
        catch (err) {
            console.error(err);
        }
    }, [props.component]);
    function sourceUpdated(src) {
        setSource(src);
        try {
            var compoennt = Common.parseTsx(src, true);
            if (compoennt && props.componentChanged) {
                props.componentChanged(compoennt);
            }
        }
        catch {
        }
    }
    return _jsx(Components.SourceEditor, { source: source, setSource: sourceUpdated, allowEdit: props.editable ?? false });
}
function filterDebugComponents(components) {
    if (!components) {
        return [];
    }
    var result = [];
    for (var component of components) {
        if (!component) {
            continue;
        }
        if (component.type === 'Text' && !component.properties?.text && !component.children) {
            continue;
        }
        if (component.type === 'DebugTextFrame' || component.type === 'DebugTextFrameToggle') {
            if (component.properties?.text) {
                result.push({ type: "Text", properties: { text: component.properties.text } });
            }
            result.push(...filterDebugComponents(component.children ?? []));
        }
        else {
            var cmp = { ...component, children: filterDebugComponents(component.children ?? []) };
            result.push(cmp);
        }
    }
    return result;
}
function buildFilteredTsx(component, indent) {
    if (component.type === 'Text') {
        return `${indent}${component.properties?.text}`;
    }
    var result = `${indent}<${component.type}`;
    for (var key in component.properties) {
        if (key !== 'text') {
            result += ` ${key}="${component.properties[key]}"`;
        }
    }
    var hasContent = false;
    if (component.properties?.text) {
        result += '>\n';
        hasContent = true;
        result += `${indent}    ${component.properties?.text}\n`;
    }
    if (component.children && component.children.length > 0) {
        result += '>\n';
        hasContent = true;
        result += buildTsxForChildren(component.children, indent + '    ') + "\n";
    }
    if (hasContent) {
        result += `${indent}</${component.type}>`;
    }
    else {
        result += ' />';
    }
    return result;
}
function buildTsxForChildren(children, indent) {
    return children.map(c => buildFilteredTsx(c, indent)).join('\n');
}
